/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/Button';
import { Title } from 'components/Text';
import fb from 'firebaseConfig';
import { StyledDialog, Content, BoxButtons } from './styles';

// Modal do Código de confirmaçÃo
const GetOutModal = ({
  open,
  onClose,
}) => {
  // Chamada para logout (Firebase)
  const logout = () => {
    if (localStorage.getItem('webview')) {
      localStorage.clear();
      localStorage.setItem('webview', 'true');
    } else {
      localStorage.clear();
    }
    fb.auth().signOut();
  };

  return (
    <StyledDialog
      open={open}
      onClose={() => onClose(false)}
    >
      <Content>
        <Title>Deseja realmente sair?</Title>
        <BoxButtons>
          <Button
            onClick={() => onClose(false)}
            variant="outlined"
          >
            Não
          </Button>
          <Button onClick={logout}>
            Sim
          </Button>
        </BoxButtons>
      </Content>
    </StyledDialog>
  );
};

GetOutModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default GetOutModal;
